import React from 'react';
import { css } from 'styled-components';
import FontStyles from 'constants/font-styles';
import Colors from 'constants/colors';
import { applyStyles } from 'util/helpers';
import CustomMedia from 'util/custom-media-query';

class GrayHeader extends React.Component {
  constructor(props) {
    super(props);
    this.ref = React.createRef();
  }

  componentDidMount() {
    const el = this.ref.current;
    const parent = el.parentElement;

    if (parent != null) {
      const height = el.clientHeight;
      const { paddingTop } = getComputedStyle(parent);
      parent.style.paddingTop = `calc(${paddingTop} + ${height}px)`;
    }
  }

  render() {
    const { className, text } = this.props;

    return (
      <header className={className} ref={this.ref}>
        <h2>{text}</h2>
      </header>
    );
  }
}

const commonStyle = css`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  background-color: ${Colors.gray4};
  text-align: center;

  h2 {
    ${FontStyles.text13};

    color: ${Colors.black1};
  }
`;

const pcStyle = CustomMedia.greaterThan('umedium')`
  height: 144px;

  h2 {
    padding-top: 46px;
    margin: 0;
  }
`;

const spStyle = CustomMedia.lessThan('medium')`
  height: 72px;

  h2 {
    padding-top: 18px;
    margin: 0;
  }
`;

export default applyStyles(GrayHeader)(commonStyle, pcStyle, spStyle);



// WEBPACK FOOTER //
// ./src/components/common/GrayHeader/index.js